'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('<', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/remark-parse/lib/locate/tag.js
// module id = 49
// module chunks = 0